import { render, staticRenderFns } from "./servicios-higiene.vue?vue&type=template&id=6d5a7f67&scoped=true&"
import script from "./servicios-higiene.vue?vue&type=script&lang=js&"
export * from "./servicios-higiene.vue?vue&type=script&lang=js&"
import style0 from "./servicios-higiene.vue?vue&type=style&index=0&id=6d5a7f67&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5a7f67",
  null
  
)

export default component.exports